import { useCallback } from 'react';
import { faTrashCan } from '@fortawesome/pro-solid-svg-icons/faTrashCan';
import { FormattedMessage } from 'react-intl';

import { IconButton } from 'ui-components/components/button/icon-button';
import { createColumnDefinitionBuilder } from 'ui-components/components/react-table-wrapper/create-column-definition-builder';

import messages from '../messages';
import style from '../style.module.less';

const ActionsCell = ({ row, handleDeleteTote }) => {
  const { id } = row?.original || {};

  const onClick = useCallback(() => {
    handleDeleteTote(id);
  }, [handleDeleteTote, id]);

  return (
    <IconButton
      ariaLabelMessageDescriptor={messages.deleteButtonLabel}
      className={style['delete-button']}
      icon={faTrashCan}
      onClick={onClick}
    />
  );
};

export const createActionsColumnDefinition = createColumnDefinitionBuilder({
  accessor: 'actions',
  Header: <FormattedMessage {...messages.actionsColumnHeader} />,
  Cell: ActionsCell,
  className: style['row-action-buttons'],
  disableSortBy: true,
  width: 120,
});
